module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921071149_T.f571720c.jpg";